import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/queries/state/useAuthQueryKeys.ts
var t = e("auth", {
	me: () => ["me"],
	state: () => ["state"]
});
//#endregion
export { t as authQueryKeys };
